<template>
  <div class="container quality-dashboard">
    <div class="title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>设施运维</el-breadcrumb-item>
        <el-breadcrumb-item>运维服务</el-breadcrumb-item>
        <el-breadcrumb-item>质量看板</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="title-en">筛选条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="园区">
                <el-select v-model="searchForm.campus_name" clearable placeholder="全部园区" style="width: 100%">
                  <el-option
                    v-for="item in campusOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="当前步骤">
                <el-select v-model="searchForm.now_step" clearable placeholder="全部步骤" style="width: 100%">
                  <el-option
                    v-for="item in stepOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="计划开始">
                <el-date-picker
                  v-model="searchForm.dateRange"
                  type="daterange"
                  range-separator="-"
                  style="width: 100%"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="关键词">
                <el-input v-model="searchForm.keyword" clearable placeholder="问题/措施/单号" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="search-button">
                <el-button type="primary" :loading="loading" @click="handleSearch">点击查询</el-button>
                <el-button @click="handleReset">重置</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <el-row :gutter="16" class="summary-row">
      <el-col :span="6" v-for="item in summaryCards" :key="item.key">
        <el-card shadow="hover" class="summary-card">
          <div class="summary-label">{{ item.label }}</div>
          <div class="summary-value" :style="{ color: item.color }">{{ item.value }}</div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="16" class="chart-row">
      <el-col :span="8">
        <el-card shadow="hover">
          <div class="section-title">园区分布</div>
          <div ref="campusChart" class="chart-box" />
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover">
          <div class="section-title">月度趋势</div>
          <div ref="monthChart" class="chart-box" />
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover">
          <div class="section-title">步骤分布</div>
          <div ref="stepChart" class="chart-box" />
        </el-card>
      </el-col>
    </el-row>

    <div class="title-en">热点问题提醒</div>
    <el-card class="box-card hotspot-card">
      <el-empty v-if="!hotspots.length" description="暂无热点问题" />
      <div v-else>
        <el-alert
          v-for="(item, index) in hotspots"
          :key="index"
          :title="`${item.issue}（${item.count} 次）`"
          type="warning"
          :closable="false"
          show-icon
          class="hotspot-item"
        >
          <div class="hotspot-meta">
            <span>涉及园区：{{ (item.campus_list || []).join('、') || '-' }}</span>
            <span>最近：{{ item.latest_time || '-' }}</span>
            <el-button type="text" @click="openDetailById(item.sample_improve_ticket_id)">查看样例</el-button>
            <el-button type="text" @click="searchByIssue(item.issue)">检索同类</el-button>
          </div>
          <div v-if="item.sample_measure" class="hotspot-measure">参考措施：{{ item.sample_measure }}</div>
        </el-alert>
      </div>
    </el-card>

    <el-tabs v-model="activeTab" class="custom-tabs">
      <el-tab-pane label="质量工单列表" name="list">
        <el-card class="box-card">
          <el-table :data="tableData" border stripe v-loading="loading">
            <el-table-column type="index" label="序号" width="60" align="center" />
            <el-table-column prop="improve_ticket_id" label="质量单号" width="150" show-overflow-tooltip />
            <el-table-column prop="service_ticket_id" label="服务单号" width="130" show-overflow-tooltip />
            <el-table-column prop="campus_name" label="园区" width="130" show-overflow-tooltip />
            <el-table-column prop="service_name" label="服务名称" min-width="220" show-overflow-tooltip />
            <el-table-column prop="evaluation_detail" label="问题描述" min-width="220" show-overflow-tooltip />
            <el-table-column prop="now_step_label" label="当前步骤" width="100" />
            <el-table-column prop="confirm_status" label="审核状态" width="90" />
            <el-table-column prop="plan_start_time" label="计划开始" width="160" />
            <el-table-column label="操作" width="90" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" @click="openDetail(scope.row)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-container">
            <el-pagination
              :current-page="currentPage"
              :page-size="pageSize"
              :page-sizes="[10, 20, 50]"
              :total="total"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </el-card>
      </el-tab-pane>

      <el-tab-pane label="历史问题与解决方案" name="solution">
        <el-card class="box-card">
          <div class="search-container">
            <el-form :inline="true" @submit.native.prevent class="search-form" label-width="100px">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="检索关键词">
                    <el-input
                      v-model="solutionKeyword"
                      placeholder="如：巡检、工时、未到场"
                      @keyup.enter.native="fetchSolutions"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="search-button">
                    <el-button type="primary" :loading="solutionLoading" @click="fetchSolutions">检索解决方案</el-button>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <el-table :data="solutionData" border stripe v-loading="solutionLoading">
            <el-table-column type="index" label="序号" width="60" align="center" />
            <el-table-column prop="improve_ticket_id" label="质量单号" width="140" />
            <el-table-column prop="campus_name" label="园区" width="120" />
            <el-table-column prop="evaluation_detail" label="问题描述" min-width="180" show-overflow-tooltip />
            <el-table-column prop="reason" label="原因分析" min-width="180" show-overflow-tooltip />
            <el-table-column prop="measure" label="改进措施" min-width="180" show-overflow-tooltip />
            <el-table-column prop="plan_start_time" label="时间" width="160" />
            <el-table-column label="操作" width="90" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" @click="openDetail(scope.row)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-container">
            <el-pagination
              :current-page="solutionPage"
              :page-size="solutionSize"
              :total="solutionTotal"
              layout="total, prev, pager, next"
              @current-change="handleSolutionPageChange"
            />
          </div>
        </el-card>
      </el-tab-pane>
    </el-tabs>

    <el-drawer title="质量工单详情" :visible.sync="detailVisible" size="50%" direction="rtl">
      <div v-if="detailData" class="detail-body">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="质量单号">{{ detailData.improve_ticket_id }}</el-descriptions-item>
          <el-descriptions-item label="服务单号">{{ detailData.service_ticket_id || '-' }}</el-descriptions-item>
          <el-descriptions-item label="园区">{{ detailData.campus_name || '-' }}</el-descriptions-item>
          <el-descriptions-item label="模组">{{ detailData.mozu_name || '-' }}</el-descriptions-item>
          <el-descriptions-item label="当前步骤">{{ detailData.now_step_label || '-' }}</el-descriptions-item>
          <el-descriptions-item label="审核状态">{{ detailData.confirm_status || '-' }}</el-descriptions-item>
          <el-descriptions-item label="结单决定">{{ detailData.complete_decision || '-' }}</el-descriptions-item>
          <el-descriptions-item label="计划开始">{{ detailData.plan_start_time || '-' }}</el-descriptions-item>
          <el-descriptions-item label="服务名称" :span="2">{{ detailData.service_name || '-' }}</el-descriptions-item>
          <el-descriptions-item label="实施人员">{{ detailData.service_engineer || '-' }}</el-descriptions-item>
          <el-descriptions-item label="园区经理">{{ detailData.campus_staff || '-' }}</el-descriptions-item>
        </el-descriptions>

        <div class="detail-block">
          <div class="detail-title">问题描述</div>
          <div class="detail-content">{{ detailData.evaluation_detail || '-' }}</div>
        </div>
        <div class="detail-block">
          <div class="detail-title">原因分析</div>
          <div class="detail-content">{{ detailData.reason || '-' }}</div>
        </div>
        <div class="detail-block highlight">
          <div class="detail-title">改进措施与计划</div>
          <div class="detail-content">{{ detailData.measure || '-' }}</div>
        </div>
        <div v-if="detailData.exe_report" class="detail-block">
          <div class="detail-title">执行报告</div>
          <div class="detail-content">{{ detailData.exe_report }}</div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import {
  getQualityDashboardDetail,
  getQualityDashboardList,
  getQualityDashboardOverview,
  searchQualityDashboardSolutions,
} from '@/api/operation';

export default {
  name: 'QualityDashboard',
  data() {
    return {
      loading: false,
      solutionLoading: false,
      activeTab: 'list',
      searchForm: {
        campus_name: '',
        now_step: '',
        dateRange: [],
        keyword: '',
      },
      campusOptions: [],
      stepOptions: [],
      summary: {},
      hotspots: [],
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      solutionKeyword: '',
      solutionData: [],
      solutionTotal: 0,
      solutionPage: 1,
      solutionSize: 10,
      detailVisible: false,
      detailData: null,
      chartInstances: [],
    };
  },
  computed: {
    summaryCards() {
      const s = this.summary || {};
      return [
        { key: 'total', label: '质量工单总数', value: s.total || 0, color: '#409EFF' },
        { key: 'closed', label: '已结单', value: s.closed || 0, color: '#67C23A' },
        { key: 'in_progress', label: '进行中', value: s.in_progress || 0, color: '#E6A23C' },
        { key: 'with_solution', label: '含改进方案', value: s.with_solution || 0, color: '#909399' },
      ];
    },
  },
  mounted() {
    this.loadDashboard();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    this.disposeCharts();
  },
  methods: {
    buildFilterParams(extra = {}) {
      const params = {
        campus_name: this.searchForm.campus_name || null,
        now_step: this.searchForm.now_step || null,
        keyword: this.searchForm.keyword || null,
        ...extra,
      };
      if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
        params.start_time = this.searchForm.dateRange[0];
        params.end_time = this.searchForm.dateRange[1];
      }
      return params;
    },
    async loadDashboard() {
      this.loading = true;
      try {
        await Promise.all([this.fetchOverview(), this.fetchList()]);
      } finally {
        this.loading = false;
      }
    },
    async fetchOverview() {
      const res = await getQualityDashboardOverview(this.buildFilterParams());
      const data = (res && res.data && res.data.data) || {};
      this.summary = data.summary || {};
      this.hotspots = data.hotspots || [];
      this.campusOptions = data.campus_options || [];
      this.stepOptions = data.step_options || [];
      this.$nextTick(() => {
        this.renderCharts(data);
      });
    },
    async fetchList() {
      const res = await getQualityDashboardList(
        this.buildFilterParams({ page: this.currentPage, size: this.pageSize })
      );
      const data = (res && res.data && res.data.data) || {};
      this.tableData = data.data || [];
      this.total = data.count || 0;
    },
    async fetchSolutions() {
      if (!this.solutionKeyword || !this.solutionKeyword.trim()) {
        this.$message.warning('请输入检索关键词');
        return;
      }
      this.solutionLoading = true;
      try {
        const res = await searchQualityDashboardSolutions({
          keyword: this.solutionKeyword.trim(),
          campus_name: this.searchForm.campus_name || null,
          page: this.solutionPage,
          size: this.solutionSize,
        });
        const data = (res && res.data && res.data.data) || {};
        this.solutionData = data.data || [];
        this.solutionTotal = data.count || 0;
      } catch (e) {
        this.$message.error('检索失败');
      } finally {
        this.solutionLoading = false;
      }
    },
    renderCharts(data) {
      this.disposeCharts();
      const campusEl = this.$refs.campusChart;
      const monthEl = this.$refs.monthChart;
      const stepEl = this.$refs.stepChart;
      if (campusEl) {
        const chart = echarts.init(campusEl);
        chart.setOption({
          tooltip: { trigger: 'axis' },
          grid: { left: 40, right: 20, bottom: 60, top: 20 },
          xAxis: {
            type: 'category',
            data: (data.by_campus || []).map((i) => i.name),
            axisLabel: { rotate: 30, interval: 0, fontSize: 10 },
          },
          yAxis: { type: 'value', minInterval: 1 },
          series: [{
            type: 'bar',
            data: (data.by_campus || []).map((i) => i.value),
            itemStyle: { color: '#409EFF' },
          }],
        });
        this.chartInstances.push(chart);
      }
      if (monthEl) {
        const chart = echarts.init(monthEl);
        chart.setOption({
          tooltip: { trigger: 'axis' },
          grid: { left: 40, right: 20, bottom: 30, top: 20 },
          xAxis: { type: 'category', data: (data.by_month || []).map((i) => i.name) },
          yAxis: { type: 'value', minInterval: 1 },
          series: [{
            type: 'line',
            smooth: true,
            data: (data.by_month || []).map((i) => i.value),
            itemStyle: { color: '#67C23A' },
          }],
        });
        this.chartInstances.push(chart);
      }
      if (stepEl) {
        const chart = echarts.init(stepEl);
        chart.setOption({
          tooltip: { trigger: 'item' },
          series: [{
            type: 'pie',
            radius: ['35%', '65%'],
            data: data.by_step || [],
            label: { formatter: '{b}: {c}' },
          }],
        });
        this.chartInstances.push(chart);
      }
    },
    disposeCharts() {
      this.chartInstances.forEach((c) => c.dispose());
      this.chartInstances = [];
    },
    handleResize() {
      this.chartInstances.forEach((c) => c.resize());
    },
    handleSearch() {
      this.currentPage = 1;
      this.loadDashboard();
    },
    handleReset() {
      this.searchForm = {
        campus_name: '',
        now_step: '',
        dateRange: [],
        keyword: '',
      };
      this.currentPage = 1;
      this.loadDashboard();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.fetchList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.fetchList();
    },
    handleSolutionPageChange(page) {
      this.solutionPage = page;
      this.fetchSolutions();
    },
    searchByIssue(issue) {
      this.activeTab = 'solution';
      this.solutionKeyword = issue.length > 30 ? issue.slice(0, 30) : issue;
      this.solutionPage = 1;
      this.fetchSolutions();
    },
    async openDetail(row) {
      if (!row || !row.improve_ticket_id) return;
      await this.openDetailById(row.improve_ticket_id);
    },
    async openDetailById(improveTicketId) {
      if (!improveTicketId) return;
      try {
        const res = await getQualityDashboardDetail({ improve_ticket_id: improveTicketId });
        this.detailData = (res && res.data && res.data.data && res.data.data.data) || null;
        this.detailVisible = true;
      } catch (e) {
        this.$message.error('获取详情失败');
      }
    },
  },
};
</script>

<style lang="less" scoped>

.quality-dashboard {
  padding: 20px;
}

.title {
  margin-bottom: 12px;
}

.title-en {
  font-size: 16px;
  font-weight: 600;
  margin: 16px 0 10px;
  color: #303133;
}

.box-card {
  margin-bottom: 16px;
}

.summary-row {
  margin-bottom: 16px;
}

.summary-card {
  text-align: center;
}

.summary-label {
  color: #909399;
  font-size: 13px;
}

.summary-value {
  font-size: 28px;
  font-weight: 700;
  margin-top: 8px;
}

.section-title {
  font-weight: 600;
  margin-bottom: 8px;
}

.chart-box {
  height: 280px;
}

.chart-row {
  margin-bottom: 8px;
}

.hotspot-item {
  margin-bottom: 12px;
}

.hotspot-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 4px;
  font-size: 12px;
  color: #606266;
}

.hotspot-measure {
  margin-top: 6px;
  font-size: 12px;
  color: #303133;
  line-height: 1.5;
}

.pagination-container {
  margin-top: 16px;
  text-align: right;
}

.detail-body {
  padding: 0 20px 20px;
}

.detail-block {
  margin-top: 16px;
}

.detail-title {
  font-weight: 600;
  margin-bottom: 8px;
  color: #303133;
}

.detail-content {
  white-space: pre-wrap;
  line-height: 1.6;
  color: #606266;
  background: #f5f7fa;
  padding: 12px;
  border-radius: 4px;
}

.detail-block.highlight .detail-content {
  background: #f0f9eb;
  border: 1px solid #e1f3d8;
}
</style>
